import { ResponseData } from 'store/details/types';
import { AdviserType, BrokerDetailsDataStructure } from 'components/DetailsPageBoilerplate/types';
import { BrokerDetailsResponseData, ProfileDetailsResponseData } from 'utils/api/types';

export const BrokerDetailsDataMapper = {
  map: (response: ResponseData<BrokerDetailsResponseData>): BrokerDetailsDataStructure => {
    const { data: responseData } = response;

    return {
      admins: responseData.assigned_supports,
      adviser: {
        id: responseData.id,
        fcaNumber: responseData.fca_number,
        company: responseData.company_name,
        name: `${responseData.first_name} ${responseData.last_name}`,
        email: responseData.email,
        phone: responseData.phone,
        lmcStatus: responseData.is_lmc_active,
      },
      availableAdmins: responseData.available_supports,
    };
  },
};

export const SupportProfileDataMapper = {
  map: (response: ResponseData<ProfileDetailsResponseData>): AdviserType => {
    const { data: responseData } = response;

    return {
      id: responseData.id,
      fcaNumber: responseData.fca_number,
      company: responseData.company_name,
      name: `${responseData.first_name} ${responseData.last_name}`,
      email: responseData.email,
      phone: responseData.phone,
      lmcStatus: responseData.is_lmc_active,
    };
  },
};
